<template>
  <div class='login_con'>
    <div class="wrap">
      <div class='login_body'>
        <el-form ref="user" :model="user" class='login_form' :rules="loginRules" v-show="!wechatLogin">
          <el-form-item>
            <h1>登录</h1>
          </el-form-item>
          <el-form-item prop='mobile'>
            <el-input placeholder="手机号" v-model="user.mobile"><i slot="prefix" class="iconfont icon-houtaiguanli" style="margin:0 5px;"></i></el-input>
          </el-form-item>
          <el-form-item prop='password'>
            <el-input placeholder="密码" v-model="user.password" type='password' @keyup.enter.native="login">
              <i slot="prefix" class="iconfont icon-Shape" style="margin:0 5px;"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class='login' @click="login">登  录</el-button>
          </el-form-item>
        </el-form>
        <div v-show="wechatLogin">
          <div id="qrCode"></div>
        </div>
        <p class='links'>
          <el-button type="text" @click="switchToWxLogin"><i class="iconfont icon-weixindenglu" style="color:green;"></i> {{wechatLogin?'账号登陆':'微信登陆'}}</el-button>
          <router-link to='/navigator/auth/forgetPass'>忘记密码</router-link>
          <router-link to='/navigator/auth/regist'>免费注册</router-link>
        </p>
      </div>
    </div>

    <SubmitSuccess :title='tips.title' :tipsMsg='tips.tipsMsg' class='prompt-pane' v-if='submitSuccessFlag' @close='submitSuccessFlag=false'></SubmitSuccess>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import taUrl from '@/static/backstageUrl';
import config from '@/static/config';

export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return;
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value)) {
        callback(new Error('手机号错误!'));
      } else {
        callback();
      }
    };
    return {
      user: {
        mobile: '',
        password: '',
      },
      getparkId:'',
      loginRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
      },
      wechatLogin: false,
      submitSuccessFlag: false,
      tips: {
        title: '提示',
        tipsMsg: '验证码发送成功',
      },
    };
  },
  methods: {
    ...mapMutations(['change_token', 'change_user']),
    login() {
      this.$refs.user.validate((valid) => {
        if (valid) {
          this.loginHttp();
        } else {
          return false;
        }
      });
    },
    // httpRequest
    loginHttp() {
      this.$http.post(`${this.URL_PREFIX}/app/user/login`, {
        loginName: this.user.mobile,
	      loginPassword: this.MD5(this.user.password),
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.getUserInfo(res.resData.token);
        } else {
          this.tips.tipsMsg = res.resDesc;
          this.submitSuccessFlag = true;
        }
      });
    },
    getUserInfo(token) {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {}, { headers: { token: token } }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_token(token);
          this.change_user(res.resData);
          // this.$router.push({ path: '/navigator', });
          this.getparkId = res.resData.parkId;
          window.location.href=`${location.href.split('/navigator/')[0]}/index?parkId=${this.getparkId}`;
        }
      });
    },
    switchToWxLogin(){
      this.wechatLogin = !this.wechatLogin
      if(this.wechatLogin){
        window.WxLogin({
          self_redirect:false,
          id:"qrCode",
          appid: config.wechatWebsiteAppId,
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent(`${taUrl.pcUrl}/navigator/auth/bindWechat`),
          state: "",
          style: "",
          href: ""
      });
      }
    }
  },
  computed: {
    ...mapGetters(['token']),
  },
  mounted(){
    // 引入微信扫码登陆依赖文件
    let load = require('load-script');
    load('https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js', {}, ()=>{
              console.log("进入")
      // 登陆类型是否为微信
      if(this.$route.query.type === 'wx'){
        console.log("微信")
        this.switchToWxLogin();
      }
    });
  },
};
</script>

<style lang='scss' scoped>
  .login_con{
    background: url('./images/login_body.jpg') no-repeat center center;
    .wrap{
      position: relative;
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      .login_body{
        float: right;
        box-sizing: border-box;
        padding: 40px;
        margin: 130px 100px;
        width: 400px;
        background: #ffffff;
        .login_form{
          .el-form-item{
            &:nth-of-type(3){
              margin-top: 40px;
            }
            &:nth-of-type(4){
              margin-top: 40px;
            }
            .iconfont{
              color: #c0c4cc;
            }
          }
          .login{
            width: 100%;
            background: #d0011b;
            color: #ffffff;
            font-size: 16px;
          }
        }
        .links{
          a{
            float: right;
            margin-left: 12px;
            color: #666666;
          }
          a:hover{
            text-decoration: underline;
          }
          .el-button{
            padding: 0
          }
        }
      }
    }

    .prompt-pane{
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    #qrCode{
      margin-left: 10px;
      margin-bottom: 20px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/auth/Login.vue